import { createAction, props } from '@ngrx/store';
import { SalesRepresentative } from 'src/models/module-wise/user/sales';

export const paginateSalesRepresentatives = createAction(
  '[ SALES REPRESENTATIVES ] Paginating'
);

export const loadSalesRepresentatives = createAction(
  '[ SALES REPRESENTATIVES ] Load Sales Representative',
  props<{ payload: SalesRepresentative[], totalDocuments: number }>()
);

export const removeSalesRepresentatives = createAction(
  '[ SALES REPRESENTATIVES ] Delete Sales Representative',
  props<{ payload: string[] }>()
);

export const removeAllSalesRepresentatives = createAction(
  '[ SALES REPRESENTATIVES]  Remove All Sales Representative'
);
